export const PAGE = {
    SEARCH: 1,
    RESERVE: 2,
    SUCCESSFUL: 3,
    FAIL: 4
}
